/**
 * Kurze Rueckmeldungen am Bildschirmrand („Produkt gespeichert", „Löschen
 * fehlgeschlagen").
 *
 * Bewusst minimal: Erfolg und Fehler. Alles Weitere gehört direkt an die Stelle, wo
 * es passiert — ein Validierungsfehler zum Beispiel unter das Feld, nicht in eine
 * Blase, die nach vier Sekunden verschwindet.
 */

import { defineStore } from 'pinia';
import { ref } from 'vue';

export type ToastKind = 'success' | 'error';

export interface Toast {
  id: number;
  kind: ToastKind;
  text: string;
}

const ANZEIGEDAUER_MS = 4000;

let naechsteId = 1;

export const useToastStore = defineStore('toasts', () => {
  const toasts = ref<Toast[]>([]);

  function entfernen(id: number): void {
    toasts.value = toasts.value.filter((toast) => toast.id !== id);
  }

  function zeigen(kind: ToastKind, text: string): void {
    const id = naechsteId++;
    toasts.value = [...toasts.value, { id, kind, text }];
    setTimeout(() => entfernen(id), ANZEIGEDAUER_MS);
  }

  return {
    toasts,
    entfernen,
    erfolg: (text: string) => zeigen('success', text),
    fehler: (text: string) => zeigen('error', text)
  };
});
